/* eslint-disable react/prop-types */
import React from 'react';

export default function FactCheckIcon({ width = 14, height = 14, color = '#6E7074' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.333496C3.33333 0.333496 0.333328 3.3335 0.333328 7.00016C0.333328 10.6668 3.33333 13.6668 7 13.6668C10.6667 13.6668 13.6667 10.6668 13.6667 7.00016C13.6667 3.3335 10.6667 0.333496 7 0.333496ZM9.8 5.86683L6.59999 9.06683C6.33333 9.3335 5.93333 9.3335 5.66666 9.06683L4.2 7.60016C3.93333 7.3335 3.93333 6.9335 4.2 6.66683C4.46666 6.40016 4.86666 6.40016 5.13333 6.66683L6.13333 7.66683L8.86666 4.9335C9.13333 4.66683 9.53333 4.66683 9.8 4.9335C10.0667 5.20016 10.0667 5.60016 9.8 5.86683Z"
        fill={color}
      />
    </svg>
  );
}
